import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller } from 'react-hook-form'
import {
  Box,
  Typography,
  Grid,
  TextField,
  MenuItem
} from '@mui/material'

const EmailReceiveProtocol = [
  { label: 'IMAP', value: 'IMAP' },
  { label: 'IMAPS', value: 'IMAPS' },
  { label: 'POP3', value: 'POP3' }
]

const ReceiverInformationFields = ({ control, errors }) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2.5, color: 'text.primary' }}>
        {t('mailTemplate.users.modal.receiverInformation')}
      </Typography>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Controller
            name="rxHostName"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.rxHostName')}
                placeholder={t('mailTemplate.users.modal.rxHostNameP')}
                {...(errors.rxHostName && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.rxHostName')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="rxPort"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.rxPort')}
                placeholder={t('mailTemplate.users.modal.rxPortP')}
                type="number"
                {...(errors.rxPort && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.rxPort')
                })}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="rxProtocol"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                select
                variant="outlined"
                size="small"
                label={t('mailTemplate.users.modal.rxProtocol')}
                defaultValue=""
                {...(errors.rxProtocol && {
                  error: true,
                  helperText: t('mailTemplate.users.modal.errors.rxProtocol')
                })}
              >
                {EmailReceiveProtocol.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReceiverInformationFields
